import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';

// components
import {CardBorder} from '../CardBorder';

// styles
import {Subtitle, TitleLarge} from '../../styles';
import {
  CardErrorContent,
  CardErrorContentTop,
  CardErrorWrapper,
  IconInformation,
} from './CardError-styles';

// types
type Props = {
  title?: string;
  message?: string;
};

const CardError = ({title, message}: Props) => {
  const {t} = useTranslation();

  return (
    <CardBorder variant="white">
      <CardErrorWrapper>
        {title && <Subtitle bold="bold">{title}</Subtitle>}
        <CardErrorContent>
          <CardErrorContentTop>
            <IconInformation />
            <TitleLarge>{t('global_error')}</TitleLarge>
          </CardErrorContentTop>
          <Subtitle>{message ?? t('global_errorOccurred')}</Subtitle>
        </CardErrorContent>
      </CardErrorWrapper>
    </CardBorder>
  );
};

export default CardError;
